/**
 * src/api/clientes.js
 * Funciones puras para el CRUD de clientes (admin).
 * Cada función retorna los datos directamente (sin el envelope de axios).
 */
import api from './client'

export const getClientes = (soloActivos = true) =>
  api.get('/admin/clientes', { params: { solo_activos: soloActivos } }).then(r => r.data)

export const getCliente = (clienteId) =>
  api.get(`/admin/clientes/${clienteId}`).then(r => r.data)

export const getUso = (clienteId) =>
  api.get(`/admin/clientes/${clienteId}/uso`).then(r => r.data)

// provisionar=true: el alta desde el panel arranca el tenant completo (pipeline
// inicial OCs histórico + precios + scheduler), sin pasar por el checkout.
export const createCliente = (data, provisionar = true) =>
  api.post('/admin/clientes', data, { params: { provisionar } }).then(r => r.data)

export const updateCliente = (clienteId, data) =>
  api.put(`/admin/clientes/${clienteId}`, data).then(r => r.data)

export const deleteCliente = (clienteId) =>
  api.delete(`/admin/clientes/${clienteId}`)

export const addCompetidor = (clienteId, data) =>
  api.post(`/admin/clientes/${clienteId}/competidores`, data).then(r => r.data)

export const updateCompetidor = (clienteId, compId, data) =>
  api.put(`/admin/clientes/${clienteId}/competidores/${compId}`, data).then(r => r.data)

export const updateEmpresa = (clienteId, empId, data) =>
  api.put(`/admin/clientes/${clienteId}/empresas/${empId}`, data).then(r => r.data)

export const updateScheduler = (clienteId, data) =>
  api.put(`/admin/clientes/${clienteId}/scheduler`, data).then(r => r.data)

export const updateTierOverride = (clienteId, data) =>
  api.put(`/admin/clientes/${clienteId}/tier-override`, data).then(r => r.data)

export const updateEstado = (clienteId, data) =>
  api.put(`/admin/clientes/${clienteId}/estado`, data).then(r => r.data)

// M2: las tiendas del tenant (cliente_familias). El endpoint existía desde el
// primer día y NINGUNA pantalla lo llamaba, así que las tiendas que un tenant
// tiene de verdad no se veían en el panel: solo el convenio del alta.
export const getFamilias = (clienteId) =>
  api.get(`/admin/clientes/${clienteId}/familias`).then(r => r.data)

// Dónde factura el tenant, tienda a tienda. Solo lectura de lo YA cacheado: no
// dispara la resolución OCDS, que es lo que haría cara esta pantalla.
export const getTiendas = (clienteId) =>
  api.get(`/admin/clientes/${clienteId}/tiendas`).then(r => r.data)

export const updateFamilia = (clienteId, famId, data, forzar = false) =>
  api.put(`/admin/clientes/${clienteId}/familias/${famId}`, data,
          { params: { forzar } }).then(r => r.data)

export const cancelarSuscripcion = (clienteId) =>
  api.post(`/admin/clientes/${clienteId}/cancelar-suscripcion`).then(r => r.data)
